// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__PtnUl","productName":"Table_productName__2Y8aK"};